/**
 * Appfolio Property Listings Filter
 * 
 * This provides custom filtering functionality for Appfolio property listings displayed via their embedded widget.
 * 
 * @overview
 * Appfolio provides a third-party property listing service that embeds listings via 
 * JavaScript. This script extends that functionality by:
 * 
 * 1. Loading Appfolio listings in an isolated iframe to prevent document.write() from overwriting the main page content
 * 2. Providing a custom dropdown filter for property groups
 * 3. Dynamically reloading the Appfolio widget when filters change without requiring a full page refresh
 * 4. Announcing filter changes to screen readers for accessibility
 * 
 * @usage
 * The script automatically initializes when:
 * - The page contains an element with id="appfolio-listings-iframe"
 * - A dropdown with id="property-groups" exists for filtering
 * - Property groups are configured via ACF field "property_groups" (comma-separated values)
 * 
 * @accessibility
 * - Uses ARIA live regions to announce loading states and filter changes
 * - Provides proper labels and semantic HTML structure
 * - Maintains keyboard navigation for all interactive elements
 * 
 * @dependencies
 * - Appfolio listing.js (loaded from urbanmgmt.appfolio.com)
 * 
 * @see views/listings.twig for the HTML structure
 */

(function() {
    function initializeListingsFilter() {
        var propertyGroupSelect = document.getElementById('property-groups');
        var listingsIframe = document.getElementById('appfolio-listings-iframe');
        var statusMessage = document.getElementById('listings-status');

        // Exit if iframe doesn't exist on this page
        if (!listingsIframe) {
            return;
        }

        /**
         * Get property group from URL parameter
         */
        function getPropertyGroupFromUrl() {
            var urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('property_group') || '';
        }

        /**
         * Update URL with selected property group
         */
        function updateUrl(selectedGroup) {
            var url = new URL(window.location);
            
            if (selectedGroup) {
                url.searchParams.set('property_group', selectedGroup);
            } else {
                url.searchParams.delete('property_group');
            }
            
            // Update URL without reloading the page
            window.history.pushState({ propertyGroup: selectedGroup }, '', url);
        }

        function loadAppfolioListings(selectedGroup) {
            // Announce loading to screen readers
            if (statusMessage) {
                statusMessage.textContent = 'Loading properties...';
            }

            // Build the config object
            var config = {
                hostUrl: 'urbanmgmt.appfolio.com',
                themeColor: '#676767',
                height: '900px',
                width: '100%',
                defaultOrder: 'date_posted'
            };

            // Add propertyGroup only if a specific group is selected
            if (selectedGroup) {
                config.propertyGroup = selectedGroup;
            }

            // Build the HTML content for the iframe
            var iframeContent = 
                '<!DOCTYPE html>' +
                '<html>' +
                '<head>' +
                '<meta charset="utf-8">' +
                '<style>body { margin: 0; padding: 0; }</style>' +
                '</head>' +
                '<body>' +
                '<script type="text/javascript" charset="utf-8">' +
                'document.write(unescape("%3Cscript src=\'" + (("https:" == document.location.protocol) ? "https:" : "http:") + "//urbanmgmt.appfolio.com/javascripts/listing.js\' type=\'text/javascript\'%3E%3C/script%3E"));' +
                '<\/script>' +
                '<script type="text/javascript" charset="utf-8">' +
                '(function checkAppfolio() {' +
                'if (typeof Appfolio !== "undefined" && typeof Appfolio.Listing === "function") {' +
                'Appfolio.Listing(' + JSON.stringify(config) + ');' +
                '} else {' +
                'setTimeout(checkAppfolio, 100);' +
                '}' +
                '})();' +
                '<\/script>' +
                '</body>' +
                '</html>';

            // Write content to iframe
            var iframeDoc = listingsIframe.contentDocument || listingsIframe.contentWindow.document;
            iframeDoc.open();
            iframeDoc.write(iframeContent);
            iframeDoc.close();

            // Announce completion to screen readers after a delay
            setTimeout(function() {
                if (statusMessage) {
                    var message = selectedGroup 
                        ? 'Properties filtered by ' + selectedGroup 
                        : 'Showing all properties';
                    statusMessage.textContent = message;
                }
            }, 1500);
        }

        // Initialize from URL parameter if present
        var initialGroup = getPropertyGroupFromUrl();
        
        // Set dropdown to match URL parameter
        if (propertyGroupSelect && initialGroup) {
            propertyGroupSelect.value = initialGroup;
        }
        
        // Load initial listings with URL parameter
        loadAppfolioListings(initialGroup);

        // Handle dropdown change
        if (propertyGroupSelect) {
            propertyGroupSelect.addEventListener('change', function() {
                var selectedGroup = this.value;
                updateUrl(selectedGroup);
                loadAppfolioListings(selectedGroup);
            });
        }

        // Handle browser back/forward navigation
        window.addEventListener('popstate', function(event) {
            var groupFromUrl = getPropertyGroupFromUrl();
            
            if (propertyGroupSelect) {
                propertyGroupSelect.value = groupFromUrl;
            }
            
            loadAppfolioListings(groupFromUrl);
        });
    }

    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeListingsFilter);
    } else {
        initializeListingsFilter();
    }

})();
